import { Banner, Bar, BarDivider, BarNav, BarNavDropDown, BarNavLink, BarNavPosition, Button, Checkbox, ColumnDefinition, ComboBox, Cooltip, DatePicker, Icon, PagingControl, RadioButton, Tab, Table, TabPanel, TextInput, ToggleButton } from '@abb/common-ux';
import * as ActionCreators from '@module/license/actionCreators/licenseAllowanceActionCreators';
import { API_ERROR_MESSAGE, API_SUPPORT_EMAIL, API_SUPPORT_MAILTO } from '@service/constants';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Option } from 'react-select';
import { IConnectedComponent } from '../../../../../reducers';
import { default as Search } from '../../../../shared/components/Search';
import { Allocation, ILicensableService, ILicenseAllowance, ISite } from '../../../models';
import { default as LicenseAllowanceTable } from './LicenseAllowanceTable';

/* tslint:disable:no-empty jsx-no-lambda jsx-self-close*/
export class LicenseAllowanceTableContainer extends React.Component<ILicenseAllowanceTableContainerProps & IConnectedComponent, any> {
  constructor(props: ILicenseAllowanceTableContainerProps & IConnectedComponent) {
    super(props);
    this.state = {
      allocationToAdd: new Allocation(),
      // TODO: grab initial value for service dropdown from this.props.serviceOptions for allocationToAdd product name and productNameBeingEdited
      productNameBeingEdited: { label: '', value: null }
    };
  }
  render() {
    const errorMessage =
      <div hidden={!this.props.licenseAllowanceErrorMessageVisible}><Banner bannerType='error' id='errorBanner' onRemove={banner => { this.props.clearErrorMessage(); }}>
        {API_ERROR_MESSAGE}
        <a href={API_SUPPORT_MAILTO}>{API_SUPPORT_EMAIL}</a>
      </Banner></div>;

    const LicenseAllowanceTableColumn = ColumnDefinition as new () => ColumnDefinition<ILicenseAllowance>;
    const canAddService = this.props.serviceOptions.licensableServices.length > 0 && !this.props.allocationIsEditing;
    const button = this.props.userPermissions && this.props.userPermissions.isAdmin
    ? (
      <div className='col-md-4 text-right align-bottom button-top-buffer'>
        <Button buttonType='normal' buttonSize='default' icon='plus' disabled={!canAddService} onClick={() => { this.handleAddNewEditableRow(this.props.licenseAllowances, this.props.match.params.siteId); }}>Add Service</Button>
      </div>
      )
    : null;

    return (
      <div className='container container-style'>
        <div className='row toolbar bottom-buffer'>
          <div className='col-md-8'>
            <h3>License Allowances</h3>
          </div>
          {button}
        </div>
        {errorMessage}
        <div className='bs'>
          <div className='row'>
            <div className='col-md-12'>
              <LicenseAllowanceTable {...this.props}></LicenseAllowanceTable>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleAddNewEditableRow(licenseAllowances: ILicenseAllowance[], siteId: number) {
    // not positive how to access the serviceOptions list from my constructor below so I am updating the product and asset type here before adding the new row
    const initialService = this.getInitialProductName(this.props.serviceOptions.licensableServices, this.props.licenseAllowances);
    this.setState({
      allocationToAdd: Object.assign({}, new Allocation(), {
        licensableService: {
          productName: initialService.productName,
          assetType: initialService.assetType,
          licenseParameters: '',
          licensePassword: '',
          id: 0,
        }
      }),
      productNameBeingEdited: Object.assign({}, this.state.productNameBeingEdited, {
        label: initialService.productName,
        value: initialService.assetType.id
      }),
      serviceBeingEdited: Object.assign({}, this.state.serviceBeingEdited, {
        productOrderNumber: {
          value: '',
          valid: false
        }
      })
    });
    this.props.AddNewEditableRow(licenseAllowances, siteId);
  }

  getInitialProductName(services: ILicensableService[], licenseAllowances: ILicenseAllowance[]): ILicensableService {
    for (const service of services) {
      if (!this.props.licenseAllowances.find((x: any) => x.licensableService.productName === service.productName)) {
        return service;
      }
    }
    return { id: -1, assetType: { id: -1, assetTypeName: '' }, licenseParameters: '', licensePassword: '', productName: '' };
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(LicenseAllowanceTableContainer) as any);

export function mapStateToProps(store: any) {
  const { access_token: accessToken } = store.userState.loggedInUser;
  return { ...store.servicesState, ...store.serviceOptionsState, ...store.serverState, userPermissions: store.userState.userPermissions, accessToken };
}

function mapDispatchToProps(dispatch: any) {
  return {
    addAllocation: (allocation: ILicenseAllowance, accessToken: string) =>
      dispatch(ActionCreators.onAddAllocation(allocation, accessToken)),
    AddNewEditableRow: (allocations: ILicenseAllowance[], siteId: number, accessToken: string) =>
      dispatch(ActionCreators.onAddNewEditableRow(allocations, siteId, accessToken)),
    EditExistingRow: (allocation: ILicenseAllowance, siteId: number, accessToken: string) =>
      dispatch(ActionCreators.onEditExistingRow(allocation, siteId, accessToken)),
    CancelAllocationEdit: (allocation: ILicenseAllowance) =>
      dispatch(ActionCreators.onCancelAllocationEdit(allocation)),
    UpdateAllocation: (allocation: ILicenseAllowance, accessToken: string) =>
      dispatch(ActionCreators.onUpdateAllocation(allocation, accessToken)),
    DeleteAllocation: (allocation: ILicenseAllowance, siteId: number, accessToken: string) =>
      dispatch(ActionCreators.onDeleteAllocation(allocation, siteId, accessToken)),
    CancelAddAllocation: () => dispatch(ActionCreators.onCancelAddAllocation()),
    clearErrorMessage: () => dispatch(ActionCreators.clearErrorMessage())
  };
}

function mergeProps({ accessToken, ...propsFromState }: any, { addAllocation, AddNewEditableRow, EditExistingRow, CancelAllocationEdit, UpdateAllocation, DeleteAllocation, clearErrorMessage, ...propsFromDispatch }: any, ownProps: any) {
  return {
    ...propsFromState,
    ...propsFromDispatch,
    ...ownProps,
    addAllocation: (allocation: ILicenseAllowance) => addAllocation(allocation, accessToken),
    AddNewEditableRow: (allocations: ILicenseAllowance[], siteId: number) => AddNewEditableRow(allocations, siteId, accessToken),
    EditExistingRow: (allocation: ILicenseAllowance, siteId: number) => {
      EditExistingRow(allocation, siteId, accessToken);
    },
    CancelAllocationEdit: (allocation: ILicenseAllowance) => {
      CancelAllocationEdit(allocation);
    },
    UpdateAllocation: (allocation: ILicenseAllowance) => UpdateAllocation(allocation, accessToken),
    DeleteAllocation: (allocation: ILicenseAllowance, siteId: number) => DeleteAllocation(allocation, siteId, accessToken),
    clearErrorMessage: () => clearErrorMessage()
  };
}

export interface ILicenseAllowanceTableContainerProps {
  licenseAllowances: ILicenseAllowance[];
  site: any;
  serviceOptions: any;
  requestServices: any;
  addAllocation: any;
  AddNewEditableRow: any;
  EditExistingRow: any;
  CancelAllocationEdit: any;
  UpdateAllocation: any;
  DeleteAllocation: any;
  CancelAddAllocation: any;
  RequestServiceTypes: any;
  allocationIsAddingNew: boolean;
  allocationIsEditing: boolean;
  match: any;
  server: any;
  renderServiceTypeComboBoxCol: any;
  permissions: string[];
  errorMessage: string;
  clearErrorMessage: any;
  licenseAllowanceErrorMessageVisible: boolean;
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/license/components/SiteLicense/LicenseAllowance/LicenseAllowanceTableContainer.tsx